import { useEffect, useRef, type ReactNode, type RefObject } from 'react'

export function MobilePicker({
  mobile,
  label,
  onClose,
  children,
  trigger,
}: {
  mobile: boolean
  label: string
  onClose: () => void
  children: ReactNode
  trigger: RefObject<HTMLButtonElement | null>
}) {
  const dialog = useRef<HTMLDialogElement>(null)
  useEffect(() => {
    if (!mobile) return
    const element = dialog.current!
    const focused = trigger.current
    const overflow = document.body.style.overflow
    const overscroll = document.documentElement.style.overscrollBehavior
    document.body.style.overflow = 'hidden'
    document.documentElement.style.overscrollBehavior = 'none'
    element.showModal()
    return () => {
      element.close()
      document.body.style.overflow = overflow
      document.documentElement.style.overscrollBehavior = overscroll
      if (focused?.isConnected) focused.focus({ preventScroll: true })
    }
  }, [mobile, trigger])
  if (!mobile) return children
  return (
    <dialog
      ref={dialog}
      className="picker-dialog"
      aria-label={label}
      onCancel={(event) => {
        event.preventDefault()
        onClose()
      }}
      onClick={(event) => {
        if (event.target === event.currentTarget) onClose()
      }}
    >
      {children}
    </dialog>
  )
}
